import type { StyleSpecification } from "maplibre-gl";

export const PLACE_LABEL_LAYER_ID = "carto-place-labels";

const CARTO_BASEMAP_KEY = (import.meta.env.VITE_CARTO_BASEMAP_KEY ?? "").trim();

function cartoRasterTileUrl(basemapName: string): string {
  const url = `https://basemaps.cartocdn.com/${basemapName}/{z}/{x}/{y}{r}.png`;
  return CARTO_BASEMAP_KEY ? `${url}?key=${encodeURIComponent(CARTO_BASEMAP_KEY)}` : url;
}

export const LIGHT_MAP_STYLE: StyleSpecification = {
  version: 8,
  sources: {
    "carto-base": {
      type: "raster",
      tiles: [cartoRasterTileUrl("light_nolabels")],
      tileSize: 256,
      attribution: "© OpenStreetMap contributors · © CARTO",
    },
    "carto-labels": {
      type: "raster",
      tiles: [cartoRasterTileUrl("light_only_labels")],
      tileSize: 256,
    },
  },
  layers: [
    {
      id: "carto-light-base",
      type: "raster",
      source: "carto-base",
      paint: { "raster-opacity": 0.98, "raster-saturation": -0.18 },
    },
    {
      id: PLACE_LABEL_LAYER_ID,
      type: "raster",
      source: "carto-labels",
      paint: { "raster-opacity": 1, "raster-contrast": 0.12 },
    },
  ],
};

